import { forwardRef } from 'react';
import DeleteButton from './DeleteButton';
import EditButton from './EditButton';

interface Props {
  onEdit: (editingRowIndex: number | null) => void;
  onDelete: () => void;
  editingRowIndex: number | null;
}

const EditAndDeleteButton = ({ onEdit, onDelete, editingRowIndex }: Props) => {
  return (
    <div className="d-inline-flex gap-2">
      <EditButton
        onClick={() => onEdit(editingRowIndex)}
        editingRowIndex={editingRowIndex}
      />
      <DeleteButton onClick={onDelete} />
    </div>
  );
};

export default EditAndDeleteButton;
